/**************************************************
 * Nombre:       Casilla_Avatar_Titulo_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";

const Casilla_Textos = ({datos, propiedades = [], dir, index}) => {

    return (
        <TableCell key={`${index}er5`} variant={'body'} align={dir}
                   sx={{color: COLORTEXTO, fontWeight: 600, fontSize: 14, minWidth: 160}}>
            <Grid container size={12} alignItems={'center'}>


                <Typography sx={{fontSize: 14, fontWeight: 600}}>
                    {propiedades.map((it, index) => {
                        return (
                            <span key={`iw${index}w6`} >{`${datos[it]}  `}</span>
                        )
                    })}
                </Typography>


            </Grid>

        </TableCell>

    )

}
export default Casilla_Textos